export const highRoles = ["Admin", "Manager", "Operator"];
export const recyclerRoles = ["Recycler", "Refurbisher"];

export const cantDonate = ["teb.com.tr", "sabanci.com"];
